// extracted by mini-css-extract-plugin
export default {"container":"DropdownTrigger_container__Z27Mm","content":"DropdownTrigger_content__cU+mY"};